import React from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalBody } from '../Modal';
import { Label } from '../Form';
import FormRow from '../Form/FormRow';
import FormColumn from '../Form/FormColumn';
import Form from '../Form/Form';
import { Credential } from '../Tester/types';
import { ISSUER_CAN_HAVE_CITY, ISSUER_CAN_HAVE_STATE } from './rules';
import FilePreview from '../File/FilePreview';
import { issuers, types } from './values';
import { format, parseISO } from 'date-fns';

type CredentialViewModalProps = {
  onClose: () => void;
  credential: Credential;
};

const CredentialViewModal: React.FC<CredentialViewModalProps> = ({
  onClose,
  credential,
}) => {
  const typeName =
    types.find((type) => type.value === credential.type)?.label ?? 'Credential';

  const issuerName = issuers.find(
    (issuer) => issuer.value === credential.issuer
  )?.label;

  const isExpired =
    credential.expireDate &&
    parseISO(credential.expireDate).getDate() <
      Date.now() - 1000 * 60 * 60 * 24;

  return (
    <Modal title={typeName} onClose={onClose}>
      <ModalBody>
        <Form>
          <FormRow>
            <FormColumn>
              <FormColumn>
                <Label>{typeName} Number</Label>
                {credential.value}
              </FormColumn>
              <FormColumn>
                <Label>Issuer</Label>
                {issuerName}
                {ISSUER_CAN_HAVE_CITY.includes(credential.issuer) &&
                  credential.city &&
                  ` of ${credential.city}`}
                {ISSUER_CAN_HAVE_STATE.includes(credential.issuer) &&
                  credential.state &&
                  ` ${credential.state}`}
              </FormColumn>
              {credential.issueDate && (
                <FormColumn>
                  <Label>Issued</Label>
                  {format(parseISO(credential.issueDate), 'MMMM d yyyy')}
                </FormColumn>
              )}
              {credential.expireDate && (
                <FormColumn>
                  <Label>{isExpired ? 'Expired' : 'Expires'}</Label>
                  {format(parseISO(credential.expireDate), 'MMMM d yyyy')}
                </FormColumn>
              )}
            </FormColumn>

            <FormColumn>
              {credential.image && (
                <FilePreview height={350} file={credential.image} />
              )}
            </FormColumn>
          </FormRow>
        </Form>
      </ModalBody>
    </Modal>
  );
};

CredentialViewModal.propTypes = {
  onClose: PropTypes.any,
  credential: PropTypes.any,
};

export default CredentialViewModal;
